import { BaseTextMergeEditor } from "../Editors/BaseTextMergeEditor";
import { BaseTextMergeElement } from "../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export class TextEditorRegistrationData {
    typeName: string;
    editorPrototype: BaseTextMergeEditor<AppGlueAny>;

    constructor(editorPrototype: BaseTextMergeEditor<AppGlueAny>, typeName: string) {
        this.typeName = typeName;
        this.editorPrototype = editorPrototype;
    }

    create(rule: BaseTextMergeElement): BaseTextMergeEditor<AppGlueAny> {
        let prototype = Object.getPrototypeOf(this.editorPrototype);

        let editor = new prototype.constructor();

        // console.log(rule.__type, editor)

        Reflect.set(editor, "editorData", rule);

        return editor;
    }
}

export class TextEditorRegistration {
    static registrations: { [key: string]: TextEditorRegistrationData } = {};

    static registerExpressionEditor(editor: BaseTextMergeEditor<AppGlueAny>, element: BaseTextMergeElement) {
        TextEditorRegistration.registrations[element.__type] = new TextEditorRegistrationData(editor, element.__type);
    }

    static getExpressionByTypeName(typeName: string): TextEditorRegistrationData | undefined {
        return TextEditorRegistration.registrations[typeName];
    }
}

export function RegisterTextEditor(editor: BaseTextMergeEditor<AppGlueAny>, element: BaseTextMergeElement) {
    TextEditorRegistration.registerExpressionEditor(editor, element);

    if (!TextEditorRegistration.getExpressionByTypeName(element.__type)) throw new Error("registration failed");
}
